module.exports = __webpack_public_path__ + "img/orange_041.89003dd5.png";